import { createContext, useContext, useState, useEffect, useRef } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
    const [notificationIsOpen, setNotificationIsOpen] = useState(false);
    const [notificationType, setNotificationType] = useState(null);
    const [notificationTitle, setNotificationTitle] = useState(null);
    const [notificationDescription, setNotificationDescription] = useState(null);
    const timeoutRef = useRef(null);

    const closeNotification = () => {
        setNotificationIsOpen(false);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
    };

    const openNotification = (type, title, description, duration = 5000) => {
        setNotificationType(type);
        setNotificationTitle(title);
        setNotificationDescription(description);
        setNotificationIsOpen(true);

        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            closeNotification();
        }, duration);
    };

    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    return (
        <NotificationContext.Provider value={{
            notificationIsOpen,
            setNotificationIsOpen,
            notificationType,
            setNotificationType,
            notificationTitle,
            setNotificationTitle,
            notificationDescription,
            setNotificationDescription,
            openNotification,
            closeNotification
        }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    return useContext(NotificationContext);
};